import api from "./utils";

const getAllResultsCount = async (data) => {
  return await api.get("/results/count").then((results) => results.data);
};

export { getAllResultsCount };
